import React from 'react';

import { Box } from '@mui/material';

import { Formik } from 'formik';

import Button from '../../../../components/Button/Button';
import { FormValue, StepOneFormValue, StepThreeFormValue, StepTwoFormValue, stepTwoSchema } from '../schema';
import './style.css';
import { Form3 } from './Forms/Form3';

type Props = {
  data: StepTwoFormValue & StepOneFormValue & StepThreeFormValue;
  handleNext: (values: StepTwoFormValue & StepOneFormValue & StepThreeFormValue) => void;
  handlePersistFormDataStep?: (values: Partial<FormValue>) => void;
};

export const Step3: React.FC<Props> = ({ data, handleNext, handlePersistFormDataStep }) => {
  return (
    <Formik
      enableReinitialize
      initialValues={data}
      validationSchema={stepTwoSchema}
      onSubmit={(values) => {
        handleNext(values);
      }}
    >
      {({ values, handleSubmit }) => {
        return (
          <Box component={'form'} onSubmit={handleSubmit}>
            <Form3 values={values} handlePersistFormDataStep={handlePersistFormDataStep} />
            <Box mt={6}>
              <Button fullWidth variant='contained' type='submit' sx={{ px: '5rem', py: '1rem' }}>
                 Create product
              </Button>
            </Box>
          </Box>
        );
      }}
    </Formik>
  );
};
